import { useContext } from "react";
import { ThemeContext } from "../context/theme";

export const useTheme = () => {
  const { theme, lang, callProfile } = useContext(ThemeContext);
  const {
    name,
    palette,
    schema,
    settingImage,
    settingCard,
    operatorId,
    settingColorWin,
    fixed_odds,
    list_bet,
    default_bet,
    seriesID,
  } = theme;
  return {
    name,
    palette,
    schema,
    settingImage,
    settingCard,
    operatorId,
    lang,
    settingColorWin,
    fixed_odds,
    list_bet,
    default_bet,
    seriesID,
    callProfile,
  };
};
